import { themed } from "@smartsheet/sds-theme-internal";
import { BaseButtonStyledProps } from "../types";

const buttonHeightTheme = themed({
    large: 40,
    medium: 32,
    small: {
        "lodestar-light": 24,
        "ursa-light": 28,
    },
    xsmall: 20,
});

export const getButtonHeight = ({ size, themeMode }: BaseButtonStyledProps): number => {
    return buttonHeightTheme[size](themeMode);
};
